import AssistantGenerateRoutesDialogByItems from './ByItems';
import AssistantGenerateRoutesDialogByTemplate from './ByTemplate';

const AssistantGenerateRoutesDialogComponents = {
  ByItems: AssistantGenerateRoutesDialogByItems,
  ByTemplate: AssistantGenerateRoutesDialogByTemplate,
};

export default AssistantGenerateRoutesDialogComponents;
